import {BrowserRouter, Route, Routes} from 'react-router-dom'
import {routeArr} from './routes'
import MainLayout from './components/layouts/mainLayout'
import {useRef, useEffect} from 'react'
import {useSelector} from 'react-redux'
import TawkMessengerReact from '@tawk.to/tawk-messenger-react'
import CustomerHelper from './utils/customer'
import TagManager from 'react-gtm-module'
import {clarity} from 'react-microsoft-clarity'

const App = () => {
    const customer = useSelector(state => state.sidebar.customer)
    const tawkMessengerRef = useRef()
    const prodEnv = 'prod'
    const tawkPropId = process.env.REACT_APP_TAWK_PROPERTY_ID
    const tawkWidgetId = process.env.REACT_APP_TAWK_WIDGET_ID

    useEffect(() => {
        const customerId = localStorage.getItem('customerId')
        const googleTagId = process.env.REACT_APP_GOOGLE_TAG_MANAGER_ID
        const clarityId = process.env.REACT_APP_CLARITY_ID

        if (customerId && !window.dataLayer && googleTagId) {
            TagManager.initialize({
                gtmId: googleTagId,
                dataLayer: {
                    userId: customerId
                }
            })
        }

        if (customerId && clarityId) {
            clarity.init(clarityId)
        }

        const onLoad = () => {
            tawkMessengerRef.current.visitor({
                name: CustomerHelper.getUserFullName(customer),
                email: customer?.email
            })
        }
        if (tawkMessengerRef.current) {
            onLoad()
        }
    }, [customer])

    return (
        <>
            {
                (Object.keys(customer).length !== 0 && process.env.REACT_APP_ENV === prodEnv && tawkPropId && tawkWidgetId) && (
                    <TawkMessengerReact
                        onLoad={() => {}}
                        propertyId={tawkPropId}
                        widgetId={tawkWidgetId}
                        ref={tawkMessengerRef}/>
                )
            }
            <BrowserRouter>
                <Routes>
                    {routeArr.map((item, index) => (
                        <Route index exact path={item.path} key={index} element={
                            <MainLayout item={item}/>
                        }
                        />
                    ))}
                </Routes>
            </BrowserRouter>
        </>
    )
}

export default App
